import React from 'react';
import './App.css';
import Routes from './Routes';

const App = () => (
  <Routes />
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js